import React, { useState } from 'react';
import { withTranslation } from "react-i18next";
import './LanguageSelector.scss';
import { useCollapse } from 'react-collapsed';

function LangSelector({ t }) {
    const [langSelector, setLangSelector] = useState(false);
    const { getCollapseProps, getToggleProps } = useCollapse({
        isExpanded: langSelector,
        duration: 600
    });

    const toggleLangClass = () => {
        setLangSelector(prev => !prev);
    };

    const activeLang = t('language');
    const languageList = t('languageSelector', { returnObjects: true });
    const languageListCollection = languageList.map((links) =>
        `${links.code}`.includes(activeLang) ?
            <li key={links.code} className="my-collapsible__content-inner active-language">
                <span>
                    {links.label}
                </span></li> :
            <li key={links.code}>
                <span>
                    <a href={`/${links.code.replace('_', '-')}?update=true`}> {links.label}</a>
                </span></li>
    );

    return (
        <button className="my-collapsible__toggle lang-select" {...getToggleProps({ onClick: toggleLangClass })}>
            <span className="icon-language"></span>
            <span className="d-none d-md-inline local-text ms-2">{t('languageText')}</span>
            <span className="active-locale text-uppercase ms-1">{`(${t('language')})`}</span>
            <span className={`d-none d-md-inline fa ${langSelector ? "fa-sort-asc" : "fa-sort-desc"}`}></span>
            <ul {...getCollapseProps()} className='my-collapsible'>
                {languageListCollection}
            </ul>
        </button>
    );
}

export default withTranslation()(LangSelector);
